/** The languages a user, a posting and a translation can be in — the CHECK
 *  list on users.lang and every *_text table. Not the languages offered in
 *  the interface; that is the shell's business. */
export const LANGS = ["zh", "en", "de"] as const;
export type Lang = (typeof LANGS)[number];

export function isLang(v: unknown): v is Lang {
  return typeof v === "string" && (LANGS as readonly string[]).includes(v);
}
